import { Box } from "@mui/material";
import React from "react";
import styles from "./styles.module.css";
import CommunityStatus from "./community-status";
import PersonalDetails from "./personal-details";
import UserLocation from "./user-location";
import Collaborate from "./collaborate";
import LoadingButton from "../../../../components/loading/button";
import { defaultProfilePrefix } from "../../../../constants";
import { useSelector } from "react-redux";

function AboutMe() {
  const { pageLoading } = useSelector((state) => state.isLoading);
  const publicUser = useSelector((state) => state.publicUser.value);

  const data = [
    {
      label: "My Real Name",
      value: publicUser?.real_name,
    },
    {
      label: "My Nickname",
      value: publicUser?.nick_name,
    },
    {
      label: "Tagline",
      value: publicUser?.tagline,
    },
    {
      label: "Profile Link",
      value: defaultProfilePrefix + publicUser?.id,
    },
    {
      label: "Pronouns",
      value: publicUser?.pronouns,
    },
    {
      label: "Age",
      value: publicUser?.generation,
    },
    {
      label: "Email Address",
      value: publicUser?.public_email || publicUser?.email,
    },
  ];

  const userLocaton = [
    {
      label: "Country",
      value: publicUser?.country,
    },
    {
      label: "City, State, County",
      value:
        publicUser?.city + ", " + publicUser?.state + ", " + publicUser?.county,
    },
  ];

  if (pageLoading) {
    return (
      <div className={styles.loading}>
        <LoadingButton />
      </div>
    );
  }

  return (
    <Box className={styles.about}>
      <CommunityStatus />
      <PersonalDetails data={data} />
      <UserLocation data={userLocaton} />
      <Collaborate />
    </Box>
  );
}

export default AboutMe;
